import { observable } from 'mobx';

export type InsuranceElementResponseArgs = {
  id: number;
  product_text: string;
};

export type InsuranceElementArgs = {
  id: number;
  productText: string;
};

export const convertInsuranceElementResponseToArgs = (response: InsuranceElementResponseArgs) => {
  const args: InsuranceElementArgs = {
    id: response.id,
    productText: response.product_text
  };
  return args;
};

export default class InsuranceElement {
  @observable
  id: number;

  @observable
  productText: string;

  constructor(args: InsuranceElementArgs) {
    this.id = args.id;
    this.productText = args.productText;
  }

  get type() {
    return 'insurance';
  }

  get title() {
    return '保険';
  }

  get summary() {
    return `[保険] ${this.productText}`;
  }

  get name() {
    return this.productText;
  }

  detail() {
    return '';
  }
}
